function initBulkRouteToolbar() {
  const checkAll  = document.getElementById('check-all');
  const rowChecks = Array.from(document.querySelectorAll('.row-check'));
  const toolbar   = document.getElementById('bulk-route-toolbar');
  const countEl   = document.getElementById('selected-count');
  const clearBtn  = document.getElementById('clear-selection');

  if (!rowChecks.length || !toolbar || !countEl) return;

  function updateToolbar() {
    const selected = rowChecks.filter(ch => ch.checked).length;
    countEl.textContent = selected;
    toolbar.classList.toggle('d-none', selected < 2);

    if (checkAll) {
      if (selected === rowChecks.length && rowChecks.length > 0) {
        checkAll.checked = true;  checkAll.indeterminate = false;
      } else if (selected > 0) {
        checkAll.checked = false; checkAll.indeterminate = true;
      } else {
        checkAll.checked = false; checkAll.indeterminate = false;
      }
    }
  }

  checkAll && checkAll.addEventListener('change', () => {
    rowChecks.forEach(ch => ch.checked = checkAll.checked);
    updateToolbar();
  });
  rowChecks.forEach(ch => ch.addEventListener('change', updateToolbar));

  clearBtn && clearBtn.addEventListener('click', () => {
    rowChecks.forEach(ch => ch.checked = false);
    updateToolbar();
  });

  updateToolbar();
}

// Com Turbo (Rails 8), rode a cada navegação
document.addEventListener('turbo:load', initBulkRouteToolbar);
// Fallback (carregamento inicial sem Turbo)
document.addEventListener('DOMContentLoaded', initBulkRouteToolbar);
